import React, { Fragment } from 'react';

import PickupOrder from '../../../models/PickupOrder';

import style from './ordersDriver.module.css';

interface DriverTruckerInfoMobileProps {
  order: PickupOrder;
};

const driverTruckerInfoMobile = (props: DriverTruckerInfoMobileProps) => {

  const { order } = props;

  return (
    <Fragment>

      <div className={ [style.pot, style.wrapper].join(' ') }>Trucker's Details</div>
    
      <div className={ [style.horizontalLineNoMargin, style.wrapper].join(' ') }></div>

      <div className={ style.wrapper }>
        <div className={ style.pot }>Trucking Company:</div>
        <div className={ style.pod }>{ order.delivery_company_name }</div>
      </div>

      <div className={ style.wrapper }>
        <div className={ style.pot }>Driver's Name:</div>
        <div className={ style.pod }>{ order.driver_name }</div>
      </div>

      <div className={ style.wrapper }>
        <div className={ style.pot }>Driver's ID type:</div>
        <div className={ style.pod }>{ order.driver_id_type }</div>
      </div>

      <div className={ style.wrapper }>
        <div className={ style.pot }>Driver's ID:</div>
        <div className={ style.pod }>{ order.driver_id ? order.driver_id.replace(/.(?=.{4,}$)/g, '#') : order.driver_id }</div>
      </div>

      <div className={ style.wrapper }>
        <div className={ style.pot }>Truck Registration:</div>
        <div className={ style.pod }>{ order.driver_vehichle_registration }</div>
      </div>
      
    </Fragment>
  );
}

export default driverTruckerInfoMobile;